import { Crumblist, Icon, ISelectOption, Select } from '@aon/aon-tws-common-ui';
import { DimensionType } from '@aon/tws-common-ui-questions/build/lib/models/enum';
import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '../../../../appStore';
import customFlag from '../../../../assets/images/icon-customFlag.png';
import ContentConstants from '../../../../contentConstants';
import { ISurveyDimension, QuestionType, SourceType } from '../../../../models';
import { ISurveyQuestionEditModel } from '../../../../models/ISurveyQuestionEditModel';
import { ActionCreators } from '../../../../store/SurveyStore';
import FollowUpQuestionResponseOptions from './FollowUpQuestionResponseOptions';

const QuestionContainer = styled.div`
	border-radius: 5px;
	margin-bottom: 6px;
	min-height: 66px;
	background-color: rgb(246, 246, 246);
	display: block;
	margin-top: 5px;
	position: relative;
`;

const CustomQuestionBanner = styled.img.attrs<{ left?: number; top?: number }>({
	className: 'icon-customFlag',
})`
	height: 40px;
	width: auto;
	position: absolute;
	top: ${(props: { left?: number; top?: number }) => (props.top ? props.top : 0)}px;
	left: ${(props: { left?: number; top?: number }) => (props.left ? props.left : 0)}px;
`;
const FlexContainer = styled.div.attrs<{ direction: string; marginTop?: number; textAlign?: string; minHeight?: number }>({
	role: 'flexContainer',
})<{ direction: string; marginTop?: number; textAlign?: string; minHeight?: number }>`
	display: flex;
	margin-top: ${(props) => (props.marginTop ? props.marginTop : 0)}px;
	flex-direction: ${(props) => props.direction};
	text-align: ${(props) => (props.textAlign ? props.textAlign : 'center')};
	min-height: ${(props) => (props.minHeight ? props.minHeight : '0')}px;
	align-item: center;
`;
const FlexItem = styled.div.attrs<{
	flexBasis: number;
	textAlign?: string;
	paddingTop?: number;
	marginTop?: number;
	marginBottom?: number;
	paddingRight?: number;
	display?: string;
	alignItems?: string;
}>({
	role: 'flexItem',
})<{
	flexBasis: number;
	textAlign?: string;
	paddingTop?: number;
	marginTop?: number;
	paddingRight?: number;
	marginBottom?: number;
	display?: string;
	alignItems?: string;
}>`
	flex: 1 1 ${(props) => props.flexBasis}%;
	padding-top: ${(props) => (props.paddingTop ? props.paddingTop : '0')}px;
	text-align: ${(props) => (props.textAlign ? props.textAlign : 'center')};
	margin-top: ${(props) => (props.marginTop ? props.marginTop : '0')}px;
	padding-right: ${(props) => (props.paddingRight ? props.paddingRight : '0')}px;
	margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : '0')}px;
	display: flex;
	flex-wrap: wrap;
	align-items: ${(props) => (props.alignItems ? props.alignItems : 'center')};
`;
export const FlexHeader = styled.div.attrs<{ flexBasis: number }>({})<{ flexBasis: number }>`
	font-size: 11px;
	font-weight: 700;
	color: #444444;
	line-height: 1.1em;
	text-transform: uppercase;
	flex: 1 1 ${(props) => props.flexBasis}%;
	text-align: left;
`;
const WarningDiv = styled.div`
	color: red;
`;
const FlexDiv = styled.div.attrs<{ flex: number }>({})<{ flex: number }>`
	flex: 1 1 ${(props) => props.flex}%;
`;

const StyledIcon = styled(Icon).attrs({
	name: 'warning',
})`
	font-size: 16px;
	margin-right: 3px;
`;
const DisplayOrderDiv = styled.div`
	flex: 1 1 8%;
	min-width: 30px;
	max-width: 45px;
	background-color: rgb(40, 171, 201);
	color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	border-top-left-radius: 4px;
	border-bottom-left-radius: 4px;
`;
const HeaderDiv = styled.div.attrs<{ flexBasis: number }>({})<{ flexBasis: number }>`
	flex: 1 1 ${(props) => props.flexBasis}%;
	min-width: 30px;
	max-width: 45px;
`;
const FollowUpCrumblistContainer = styled.div`
	margin-top: 6px;
	text-align: left;
`;

export interface IFollowUpQuestionOptionMax {
	value: number;
	question: ISurveyQuestionEditModel;
}
export interface IFollowUpQuestionOptions {
	values: string[];
	question: ISurveyQuestionEditModel;
}
export interface IFollowUpQuestionRow {
	question: ISurveyQuestionEditModel;
}
export interface ISelectedDimensionCrumb {
	displayText: string;
	value: string;
}

export default function FollowUpQuestionRow(props: IFollowUpQuestionRow) {
	const { question } = props;
	const dispatch = useAppDispatch();
	const surveyDimensions: ISurveyDimension[] = useAppSelector((store) => {
		return store.surveyDimensions.surveyDimensions;
	});
	const followUpQuestionOptions: ISelectOption[] = useAppSelector((store) => {
		const surveyEditModel = store.survey.surveyEditModel;
		let dimensionOptions: string[] = [];
		surveyEditModel.questions.forEach((q) => {
			if (q.dimensionNames) {
				dimensionOptions = dimensionOptions.concat(
					q.dimensionNames.filter((dn) => surveyDimensions.some((d) => d.name === dn && d.dimensionType === DimensionType.Dimension)),
				);
			}
		});
		return _.uniq(dimensionOptions).map((x: string) => {
			return { name: x, displayText: x } as ISelectOption;
		});
	});

	const selectionLimit = question.selectionLimit && question.questionType != QuestionType.Scale ? props.question.selectionLimit : 1;
	const selectedDimensions: ISelectedDimensionCrumb[] = question.responseOptions
		? question.responseOptions
				.filter((x) => followUpQuestionOptions.some((o) => o.name === x))
				.map((q) => {
					return { displayText: q, value: q };
				})
		: [];

	const maxOptions: ISelectOption[] = Array(selectedDimensions.length === 0 ? followUpQuestionOptions.length : selectedDimensions.length)
		.fill(0)
		.map((_, index) => {
			return { name: String(index + 1), displayText: index + 1 } as ISelectOption;
		});

	function HandleUserApplyNewDimensions(values?: string | string[] | undefined): void {
		dispatch(ActionCreators.UpdateFollowUpQuestionOptions({ values: values as string[], question: props.question }));
	}
	function HandleMaxValueUpdateForOptionGroup(values?: string | string[] | undefined) {
		dispatch(ActionCreators.UpdateFollowUpQuestionMaxOption({ value: Number(values), question: props.question }));
	}

	return (
		<div style={{ display: 'flex', flexDirection: 'row', paddingBottom: '10px' }}>
			<FlexDiv flex={5}></FlexDiv>
			<FlexDiv flex={96}>
				<FlexContainer direction='row' marginTop={8}>
					<HeaderDiv flexBasis={8}></HeaderDiv>
					<div style={{ width: '10px' }}></div>
					<FlexHeader flexBasis={50}>{ContentConstants.FOLLOWUP_QUESTION_HEADER}</FlexHeader>
					<FlexHeader flexBasis={24}>{ContentConstants.FOLLOWUP_QUESTION_HEADER_RESPONSESE_OPTIONS}</FlexHeader>
					<FlexHeader flexBasis={12}>{ContentConstants.FOLLOWUP_QUESTION_HEADER_MAX_RESPONSESES}</FlexHeader>
					<FlexHeader flexBasis={1}></FlexHeader>
				</FlexContainer>
				<QuestionContainer>
					<FlexContainer direction='row' minHeight={66}>
						<DisplayOrderDiv>{question.displayOrder}</DisplayOrderDiv>
						{question.sourceType === SourceType.Custom && <CustomQuestionBanner src={customFlag} top={-0} left={0} />}
						<div style={{ width: '10px' }}></div>
						<FlexItem flexBasis={50} textAlign={'left'} marginTop={6} marginBottom={6}>
							<div>{question.text}</div>
							{selectedDimensions.length === 0 && (
								<WarningDiv>
									<StyledIcon name='warning'></StyledIcon>
									{ContentConstants.FOLLOWUP_QUESTION_NO_DIMENSION_WARNING}
								</WarningDiv>
							)}
						</FlexItem>
						<FlexItem flexBasis={24} paddingRight={12} paddingTop={12} alignItems={'flex-start'}>
							<FollowUpQuestionResponseOptions
								dimensionOptions={followUpQuestionOptions}
								selectedValues={selectedDimensions.map((x) => x.value)}
								applyDimension={HandleUserApplyNewDimensions}
							></FollowUpQuestionResponseOptions>
							<FollowUpCrumblistContainer>
								<Crumblist data={selectedDimensions} />
							</FollowUpCrumblistContainer>
						</FlexItem>
						<FlexItem flexBasis={8} textAlign={'left'} paddingTop={12} alignItems={'flex-start'}>
							<Select
								size='sm'
								dropdownSize='sm'
								onApply={HandleMaxValueUpdateForOptionGroup}
								items={maxOptions}
								selectedValue={String(selectionLimit)}
								disabled={question.questionType == QuestionType.Scale || followUpQuestionOptions.length === 0}
							></Select>
						</FlexItem>
						<FlexItem flexBasis={5}></FlexItem>
					</FlexContainer>
				</QuestionContainer>
			</FlexDiv>
		</div>
	);
}
